import { User } from '@/types';
import type { ReactNode, Dispatch, SetStateAction } from 'react';
import { createContext, useContext, useState } from 'react';
import { useLocaleSyncFonts } from '@/utils/locale';

interface AppContextType {
  user: User | null;
  setUser: Dispatch<SetStateAction<User | null>>;
}

const AppContext = createContext<AppContextType | null>(null);
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppContext.Provider');
  }
  return context;
};

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  useLocaleSyncFonts();

  return (
    <AppContext.Provider value={{ user, setUser }}>
      {children}
    </AppContext.Provider>
  );
};
